import * as Yup from 'yup';

const requiredMessage = 'Required';

export const schemaValidation = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .nullable(requiredMessage)
    .required(requiredMessage),
  lastName: Yup.string()
    .trim()
    .nullable(requiredMessage)
    .required(requiredMessage),
});
